import AcademicStructure from "../pages/academic/AcademicStructure";

function AcademicRoutes() {
    return [
        {
            path: '/academic-structure',
            element: <AcademicStructure />
        }
    ];
}

export default AcademicRoutes;
